import { render } from "./Settings.vue?vue&type=template&id=068bbcbb&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=068bbcbb&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=068bbcbb&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068bbcbb"]])

export default __exports__